import { jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useTranslation } from "../../../contexts/translation-context.js";
import { FileInputWUT } from "../../../inputs/file-input/file-input-wut.js";
import { dataUrlToWixFile } from "../utils/data-url.js";
import styles from "./signature-upload-wut.module.scss";
const SignatureUploadWUT = ({
  id,
  onFocus,
  onBlur,
  disabled,
  required = false,
  readOnly,
  ariaLabelledBy,
  ariaDescribedBy,
  handleChange,
  hasError = false
}) => {
  const { t } = useTranslation();
  const fileUploadButtonRef = useRef(null);
  const fileInputRef = useRef(null);
  const textBelowButtonRef = useRef(null);
  const handleFileChange = (files) => {
    if (!files || files.length === 0) {
      handleChange(null);
      return;
    }
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onload = function() {
      handleChange(dataUrlToWixFile(this.result, file.name));
    };
    fileReader.readAsDataURL(file);
  };
  return /* @__PURE__ */ jsx("div", { className: styles.container, children: /* @__PURE__ */ jsx(
    FileInputWUT,
    {
      onFocus,
      onBlur,
      disabled: disabled || readOnly,
      buttonText: t("field.signature.settings.upload-button.label"),
      valueSliderLimit: 1,
      required,
      inputId: id,
      ariaLabelledBy,
      ariaDescribedBy,
      files: [],
      handleChange: handleFileChange,
      accept: "image/*",
      fileUploadButtonRef,
      fileInputRef,
      textBelowButtonRef,
      hover: false,
      fieldId: id,
      hasError,
      "data-hook": "signature-upload"
    }
  ) });
};
export {
  SignatureUploadWUT
};
//# sourceMappingURL=signature-upload-wut.js.map
